// extracted by css-extract-rspack-plugin
export default {"root":"w4syXZexA4DfLp0Y","branding":"wbdAQ39QEYMRxJcn"};